import { gql } from '@apollo/client';

const MUTATION_REPLACE_CUSTOMER_CART = gql`
    mutation replaceCustomerCart(
        $cartId: String!
        $products: [ReplaceCustomerCartProductInput!]!
        $accessories: String
    ) {
        replaceCustomerCart(input: { cart_id: $cartId, products: $products, accessories: $accessories }) {
            success
            new_cart_id
            message
            cart {
                id
                updated_at
                created_at
                total_quantity
                accessoriesnaddons
                items {
                    uid
                    quantity
                    product {
                        name
                        sku
                        product_page_url
                        ec_pc_inventory
                        isOverSize
                        isOverWeight
                        category_name
                        parent_category_name
                        category_path
                        productcatsortindex
                        disableaddtocartoption
                        showonlinecatalog
                        greenleafdata
                        isgreenleaf
                        categories {
                            category_page_url
                            id
                            name
                        }
                        thumbnail {
                            url
                        }
                    }
                    ... on BundleCartItem {
                        bundle_options {
                            id
                            label
                            type
                            values {
                                id
                                label
                                price
                                quantity
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default MUTATION_REPLACE_CUSTOMER_CART;